import { FC } from "react";
import { FieldWidth, ToggleField } from "./FormSection.props";
import Grid from "../Grid";
import { Toggle } from "../FormElements";
import { useFormContext } from "../Form";

/**
 * @deprecated
 */
export const FormSectionToggle: FC<ToggleField> = ({ name, label, toggleSize, isEditable, width }: ToggleField) => {
  const { readOnly } = useFormContext();

  return (
    <Grid item colLg={width === FieldWidth.HALF ? 6 : 12} id="form-grid-item">
      <Toggle id={name} toggleLabel={label} name={name} readOnly={readOnly || !isEditable} toggleSize={toggleSize} />
    </Grid>
  );
};
